export default __webpack_public_path__ + "static/media/Arrow - Right Square.dc7bd78f.svg";